// LiturgicalBadge — selo "Semana Litúrgica / Calendário Cristão" (mesmo padrão do site).
// Renderiza somente quando weekly_theme.is_liturgical é true. Silêncio elegante.
// JourneyDayLabel — identidade de jornada "Dia X de 365". Linguagem sem culpa:
// nunca cobra ausência, apenas situa o leitor na caminhada anual.
import React from "react";
import { Sparkles } from "lucide-react";

export const LiturgicalBadge = ({
  weeklyTheme,
  testid = "liturgical-badge",
  className = "",
  showThemeName = true,
}) => {
  if (!weeklyTheme || weeklyTheme.is_liturgical !== true) return null;
  const label =
    weeklyTheme.liturgical_category === "civil" ? "Calendário Cristão" : "Semana Litúrgica";
  return (
    <span
      data-testid={testid}
      data-event-key={weeklyTheme.liturgical_event_key || ""}
      data-category={weeklyTheme.liturgical_category || ""}
      className={`inline-flex items-center gap-1.5 rounded-full border border-gold/45 bg-gold/10 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-navy ${className}`}
    >
      <Sparkles className="w-3 h-3 text-gold" />
      {label}
      {showThemeName && weeklyTheme.theme_name ? (
        <span className="hidden sm:inline normal-case tracking-normal text-navy/70">
          · {weeklyTheme.theme_name}
        </span>
      ) : null}
    </span>
  );
};

export const JourneyDayLabel = ({ cycleDay, testid = "journey-day", className = "" }) => {
  const n = Number(cycleDay);
  if (!Number.isFinite(n) || n < 1 || n > 365) return null;
  return (
    <span
      data-testid={testid}
      title="Sua caminhada na Palavra, no seu ritmo"
      className={`text-[10px] uppercase tracking-[0.25em] text-gold tabular-nums ${className}`}
    >
      Dia {n} de 365
    </span>
  );
};
